// extracted by mini-css-extract-plugin
export default {"container":"wifi-advanced_container__52OfN","headline":"wifi-advanced_headline__RUY1+"};